import { SVGProps } from 'react'

export const CoinsSwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.00008 4.99984L6.66675 3.33317M6.66675 3.33317L5.00008 1.6665M6.66675 3.33317H5.00008C3.15913 3.33317 1.66675 4.82555 1.66675 6.6665M15.0001 14.9998L13.3334 16.6665M13.3334 16.6665L15.0001 18.3332M13.3334 16.6665H15.0001C16.841 16.6665 18.3334 15.1741 18.3334 13.3332M8.49094 5.4165C9.04599 3.25997 11.0036 1.6665 13.3334 1.6665C16.0948 1.6665 18.3334 3.90508 18.3334 6.6665C18.3334 8.99629 16.74 10.9539 14.5835 11.509M11.6667 13.3332C11.6667 16.0946 9.42817 18.3332 6.66675 18.3332C3.90532 18.3332 1.66675 16.0946 1.66675 13.3332C1.66675 10.5717 3.90532 8.33317 6.66675 8.33317C9.42817 8.33317 11.6667 10.5717 11.6667 13.3332Z"
      stroke="#01A4FE"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
